import React, { useEffect, useContext, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  getSystemSettings,
  formatPrice,
  customStyle,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { useCustomHooks } from "../../../../../functions/Hooks";

//3rd party packages
import { Helmet } from "react-helmet";
import { ToastError, ToastSuccess } from "../../../../../functions/ToastShow";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//context consumer
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import { SettingsContext } from "../../../../../contexts/Settings";

const PurchaseOrderAction = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { roundOffStock, qtyAmountPoints } = useCustomHooks();
  //getting context values here
  let {
    loading,
    setLoading,
    branchForSearch,
    branchForListSearch,
    getIngredientItem,
    ingredientItemNonPurchase,
    dataPaginating,
  } = useContext(RestaurantContext);
  let { getSupplier, supplierForSearch } = useContext(UserContext);
  const { generalSettings } = useContext(SettingsContext);

  const { id } = useParams();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const isReplicated = query.get("duplicate");
  // States hook here
  //new item
  let [newItem, setNewItem] = useState({
    branch: null,
    date: new Date(),
    delivery_date: new Date(),
    supplier: null,
    description: "",
    purchase_req: "",
    is_ref_no: 0,
    edit: false
  });

  const [purchaseReqRef, setPurchaseReqRef] = useState([]);

  //new Row
  const [newRow, setNewRow] = useState([]);

  //useEffect == componentDidMount()
  useEffect(() => {
    if (!supplierForSearch) {
      getSupplier();
    }
    if (!ingredientItemNonPurchase) {
      getIngredientItem()
    }
  }, []);

  const getItemRate = async (supplier_id, branch_id, item_id) => {
    const url = BASE_URL + "/settings/purchaseorder-item-rate";
    const formData = {
      branch_id: branch_id,
      item_id: item_id,
      supplier_id: supplier_id,
    }
     try {
      const res = await axios.post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
      const rate = res.data;
      if(rate){
        return res.data
      }
    } catch {
      setLoading(false);
    }
  };

  const getItemUnit = async(item)=>{
    const url = BASE_URL + "/settings/get-unit_item/" + item.id;
    try{
      const res = await axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      if(res){
        return res.data;
      }
    }catch(err){
      console.log("check error", err);
    }
  }

  const getPurchasedItem = async () => {
    const url = BASE_URL + "/settings/purchase-order/" + parseInt(id);
    setLoading(true)
    try {
      const res = await axios
        .get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
      const editOrder = res.data;
      if (editOrder) {
        let date = new Date(editOrder.document_date);
        const deliveryDate = new Date(editOrder.delivery_date);
        let suplier = supplierForSearch?.find(item => item?.id === editOrder.supplier_id);
        const branch = branchForListSearch[editOrder.branch_id]
        setNewItem({
          ...newItem,
          date,
          delivery_date: deliveryDate,
          branch,
          supplier: suplier,
          is_ref_no: editOrder.ref_document_identity ? 1 : 0,
          purchase_req: { id: null, document_identity: editOrder.ref_document_identity },
          description: !editOrder.remarks ? "" : editOrder.remarks,
          identity: editOrder.document_identity,
          edit: true
        })
        let slugArr = [];
        if (editOrder.purchase_order_detail && editOrder.purchase_order_detail.length > 0) {
          editOrder.purchase_order_detail.map((item, index) => {
            slugArr.push({
              ...item,
              id: index,
              qty: roundOffStock(item.qty),
              remaining_qty: roundOffStock(item.pr_qty),
              rate: roundOffStock(item.rate),
              amount: roundOffStock(item.amount),
              tax_percent: item.tax_percent !== undefined && item.tax_percent !== null ? roundOffStock(item.tax_percent) : (item.gst_tax !== undefined && item.gst_tax !== null ? roundOffStock(item.gst_tax) : ""),
              tax: item.tax !== undefined && item.tax !== null ? roundOffStock(item.tax) : (item.tax_amount !== undefined && item.tax_amount !== null ? roundOffStock(item.tax_amount) : ""),
              gst_tax: item.gst_tax !== undefined && item.gst_tax !== null ? roundOffStock(item.gst_tax) : "",
              base_qty: roundOffStock(item.base_qty),
              conversion_qty: roundOffStock(item.conversion_qty),
              isEdit: true,
            })
          })
          setNewRow([...slugArr]);
        }
      }
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id && supplierForSearch) {
      getPurchasedItem()
    }
  }, [id, supplierForSearch])

  //on change input field
  const handleDesc = (e) => {
    setNewItem({ ...newItem, description: e.target.value });
  };

  //get purchase req ref
  const handlePurchaseReqRef = async (branch_id) => {
    const url = BASE_URL + "/settings/get-pr-list/" + branch_id;
    try {
      setLoading(true)
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if (res.data) {
        setNewRow([]);
        setLoading(false);
        setPurchaseReqRef(res.data)
      }
      setLoading(false);
    } catch {
      setLoading(false);
    }
  }

  const handleSetRefNo = (data) => {
    setNewItem({ ...newItem, purchase_req: data })
    if (data) {
      if (data?.purchase_request_detail && data.purchase_request_detail.length > 0) {
        let slugArr = [];
        data.purchase_request_detail.map((item, index) => {
          slugArr.push({
            ...item,
            id: index,
            qty: (Number(item.qty) > Number(item?.remaining_qty)) ? item?.remaining_qty : item?.qty,
            tax_percent: item.tax_percent !== undefined && item.tax_percent !== null ? roundOffStock(item.tax_percent) : (item.gst_tax !== undefined && item.gst_tax !== null ? roundOffStock(item.gst_tax) : ""),
            tax: item.tax !== undefined && item.tax !== null ? roundOffStock(item.tax) : (item.tax_amount !== undefined && item.tax_amount !== null ? roundOffStock(item.tax_amount) : ""),
            gst_tax: item.gst_tax !== undefined && item.gst_tax !== null ? roundOffStock(item.gst_tax) : "",
            isEdit: true,
          })
        })
        setNewRow([...slugArr]);
      }
    } else {
      setNewRow([]);
    }
  }

  //handle Set branch hook
  const handleSetBranch = (branch) => {
    setNewItem({ ...newItem, branch, purchase_req: "" });
    if (branch && newItem.is_ref_no) {
      handlePurchaseReqRef(branch.id);
    }
  };

  //set items hook
  const handleSetItems = async (index, item) => {
    newRow[index].unit = "";
    newRow[index].base_unit = "";
    newRow[index].base_qty = "";
    newRow[index].conversion_qty = "";
    newRow[index].item_name = item;
    newRow[index].base_unit = item.unit_id;
    newRow[index].item_units = "";
    const taxPercentVal = item?.tax_percent !== undefined && item?.tax_percent !== null ? roundOffStock(item.tax_percent) : (item?.gst_tax !== undefined && item?.gst_tax !== null ? roundOffStock(item.gst_tax) : "");
    newRow[index].tax_percent = taxPercentVal;
    newRow[index].tax = item?.tax !== undefined && item?.tax !== null ? roundOffStock(item.tax) : "";
    newRow[index].gst_tax = taxPercentVal;
    setNewRow([...newRow]);
    const rate = await getItemRate(newItem.supplier?.id ?? "", newItem.branch?.id ?? "", item.id);
    const units = await getItemUnit(item);
    if (units || rate) {
      if(units){
        newRow[index].item_units = units;
        newRow[index].unit = units[1];
        newRow[index].conversion_qty = roundOffStock(units[1].qty);
      }
      if(rate){
        newRow[index].rate = rate?.data ?? "";
      }
      setNewRow([...newRow]);
    }
  };

  //handle unit
  const handleSetUnit = (index, unit) => {
    newRow[index].unit = unit;
    newRow[index].conversion_qty = roundOffStock(unit.qty);
    setNewRow([...newRow]);
  }

  //get item tax amount
  const handleGetTaxAmount = (index) => {
    let qty = 0;
    let rate = 0;
    let taxPercent = 0;
    if (newRow !== null && newRow[index]?.qty) {
      qty = parseFloat(newRow[index].qty);
    }
    if (newRow !== null && newRow[index]?.rate) {
      rate = parseFloat(newRow[index].rate);
    }
    if (newRow !== null) {
      const rowItem = newRow[index];
      if (rowItem?.tax_percent !== undefined && rowItem?.tax_percent !== "" && rowItem?.tax_percent !== null) {
        taxPercent = parseFloat(rowItem.tax_percent);
      } else if (rowItem?.tax !== undefined && rowItem?.tax !== "" && rowItem?.tax !== null) {
        taxPercent = parseFloat(rowItem.tax);
      } else if (rowItem?.gst_tax !== undefined && rowItem?.gst_tax !== "" && rowItem?.gst_tax !== null) {
        taxPercent = parseFloat(rowItem.gst_tax);
      }
    }
    return roundOffStock((rate * qty * taxPercent) / 100);
  };

  const handleGetGstAmount = handleGetTaxAmount;

  //amount before tax
  const handleGetAmount = (index) => {
    let qty = 0;
    let rate = 0;
    if (newRow !== null && newRow[index]?.qty) {
      qty = parseFloat(newRow[index].qty);
    }
    if (newRow !== null && newRow[index]?.rate) {
      rate = parseFloat(newRow[index].rate);
    }
    return roundOffStock(rate * qty);
  };

  //subtotal (includes tax amount)
  const handleGetSubTotal = (index) => {
    let taxAmount = handleGetTaxAmount(index);
    return roundOffStock(handleGetAmount(index) + taxAmount);
  };

  //total
  const handleGetTotal = () => {
    let total = 0;
    if (newRow !== null) {
      newRow.forEach((item, index) => {
        total = total + handleGetSubTotal(index);
      });
    }
    return roundOffStock(total);
  };

  const handleGetTotalTaxAmount = () => {
    let totalTax = 0;
    if (newRow !== null) {
      newRow.forEach((item, index) => {
        totalTax = totalTax + handleGetTaxAmount(index);
      });
    }
    return roundOffStock(totalTax);
  };

  //set each item qty
  const handleItemQty = (index, e) => {
    newRow[index].qty = e.target.value;
    setNewRow([...newRow]);
  };

  //set each item qty
  const handleItemRate = (index, e) => {
    newRow[index].rate = e.target.value;
    setNewRow([...newRow]);
  };

  const handleItemTax = (index, e) => {
    newRow[index].tax_percent = e.target.value;
    newRow[index].tax = e.target.value;
    newRow[index].gst_tax = e.target.value;
    setNewRow([...newRow]);
  };

  const handleItemGstTax = handleItemTax;

  const handleCheckRef = () => {
    setNewItem({ ...newItem, is_ref_no: newItem.is_ref_no ? 0 : 1 })
    if (!newItem.is_ref_no) {
      if (newItem.branch) {
        handlePurchaseReqRef(newItem.branch.id)
      }
    }
  }

  //get supplier items
  const getIngredientSupplier = async (id) => {
    const url = BASE_URL + "/settings/edit-supplier/" + id
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      return res.data;
    } catch (err) {
      ToastError({ title: `${_t(t("Failed to fetch supplier items"))}` });
    }
  }

  //handle Set supplier hook
  const handleSetSupplier = async (supplier) => {
    setNewItem({ ...newItem, supplier });
    if (newItem.is_ref_no === 0) {
      const supplierItems = await getIngredientSupplier(supplier?.id);
      if (supplierItems?.ingredient_items && supplierItems.ingredient_items?.length) {
        setLoading(true);
        const items = await Promise.all(supplierItems.ingredient_items.map(async(item, index) => {
          // const units = await getUnits(item.id,index);
          const rate = await getItemRate(supplier?.id ?? "", newItem.branch?.id ?? "", item.id)
          const units = [item.base_unit, item.default_unit];
          return {
            id: index,
            item_name: item,
            qty: "",
            unit: item.default_unit,
            item_units: units,
            rate: rate?.data ?? "",
            tax_percent: item?.tax_percent !== undefined && item?.tax_percent !== null ? roundOffStock(item.tax_percent) : (item?.gst_tax !== undefined && item?.gst_tax !== null ? roundOffStock(item.gst_tax) : ""),
            tax: item?.tax !== undefined && item?.tax !== null ? roundOffStock(item.tax) : (item?.tax_amount !== undefined && item?.tax_amount !== null ? roundOffStock(item.tax_amount) : ""),
            gst_tax: item?.gst_tax !== undefined && item?.gst_tax !== null ? roundOffStock(item.gst_tax) : "",
            base_unit: item?.unit_id,
            base_qty: "",
            conversion_qty: roundOffStock(units[1].qty)
          }
        }));
        setLoading(false);
        setNewRow([...items]);
      }
    }
  };

  //post req of food item add
  const ingredientItemAxios = async () => {
    // setLoading(true);
    let date =
      new Date(newItem.date).getFullYear() +
      "-" +
      (new Date(newItem.date).getMonth() + 1) +
      "-" +
      new Date(newItem.date).getDate();

    let delDate = new Date(newItem.delivery_date).getFullYear() +
      "-" +
      (new Date(newItem.delivery_date).getMonth() + 1) +
      "-" +
      new Date(newItem.delivery_date).getDate();

    //converting items and prices to array
    let duplicate = {};
    const duplicateItem = [];
    let slugArray = [];
    newRow.map((newIngredientItem, index) => {
      if (duplicate[newIngredientItem?.item_id || newIngredientItem.item_name.id]) {
        duplicateItem.push({
          item_id: newIngredientItem?.item_id || newIngredientItem.item_name.id,
          item_name: newIngredientItem.item_name?.name || newIngredientItem.item_name,
        })
      }
      if (newIngredientItem.item_name === "" || newIngredientItem.unit === "") {
        slugArray.push();
      } else {
        duplicate[newIngredientItem?.item_id || newIngredientItem.item_name.id] = true;
        slugArray.push({
          qty: newIngredientItem.qty,
          remaining_qty: newIngredientItem?.remaining_qty ?? 0,
          rate: newIngredientItem.rate,
          tax_percent: newIngredientItem.tax_percent !== "" && newIngredientItem.tax_percent !== undefined && newIngredientItem.tax_percent !== null ? parseFloat(newIngredientItem.tax_percent) : ((newIngredientItem.gst_tax !== "" && newIngredientItem.gst_tax !== undefined && newIngredientItem.gst_tax !== null) ? parseFloat(newIngredientItem.gst_tax) : 0),
          tax: handleGetTaxAmount(index),
          gst_tax: newIngredientItem.tax_percent !== "" && newIngredientItem.tax_percent !== undefined && newIngredientItem.tax_percent !== null ? parseFloat(newIngredientItem.tax_percent) : ((newIngredientItem.gst_tax !== "" && newIngredientItem.gst_tax !== undefined && newIngredientItem.gst_tax !== null) ? parseFloat(newIngredientItem.gst_tax) : 0),
          item_id: newIngredientItem.isEdit ? newIngredientItem.item_id : newIngredientItem.item_name.id,
          item_name: newIngredientItem.isEdit ? newIngredientItem.item_name : newIngredientItem.item_name.name,
          unit_id: newIngredientItem.isEdit ? newIngredientItem.unit_id : newIngredientItem.unit.id,
          unit_name: newIngredientItem.isEdit ? newIngredientItem.unit_name : newIngredientItem.unit.name,
          amount: handleGetSubTotal(index),
          base_unit: newIngredientItem.base_unit,
          base_qty: calBaseQty(index),
          conversion_qty: parseFloat(newIngredientItem.conversion_qty)
        });
      }
    });

    if (duplicateItem?.length) {
      ToastError({ title: `${_t(t(`Duplicate item ${duplicateItem[0].item_name} found`))}` });
      return;
    }

    let formData = {
      branch_id: newItem.branch.id,
      branch_name: newItem.branch.name,
      pr_document_identity: newItem.purchase_req ? newItem.purchase_req?.document_identity : "",
      supplier_id: newItem.supplier.id,
      supplier_name: newItem.supplier.name,
      document_date: date,
      delivery_date: delDate,
      remarks: newItem.description,
      total_amount: handleGetTotal(),
      total_tax: handleGetTotalTaxAmount(),
      items: slugArray
    }

    if (newRow.length === slugArray.length) {
      setLoading(true);
      const endPoint = (id && !isReplicated) ? ("/settings/purchase-order/" + id) : "/settings/purchase-order";
      const url = BASE_URL + endPoint;
      const method = (id && !isReplicated) ? "put" : "post";
      try {
        const res = await axios[method](url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        setLoading(false);
        ToastSuccess({ title: `${_t(t((id && !isReplicated) ? "Purchase Order has been updated" : "Purchase Order has been added"))}` });
        history.push("/dashboard/manage/stock/purchase-order")
      } catch (error) {
        setLoading(false);
        if(error.response.data.status === 0){
          ToastError({ title: error.response.data.message})
          return false;
        }
        ToastError({ title: `${_t(t("Please try again later"))}` });
      }
    } else {
      ToastError({ title: `${_t(t("Please select all dropdowns"))}` });
    }
  };

  //send to server
  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      newItem.branch !== null &&
      newItem.supplier !== null &&
      newItem.date !== null
    ) {
      if (newRow.length > 0) {
        ingredientItemAxios();
      } else {
        ToastError({ title: `${_t(t("Please add orders"))}` });
      }
    } else {
      ToastError({ title: `${_t(t("Please fill all required fields"))}` });
    }
  };

  const calBaseQty = (index) => {
    let qty = newRow[index].qty;
    let conversion_qty = newRow[index].conversion_qty
    if (qty && conversion_qty) {
      return roundOffStock(qty * conversion_qty);
    } else {
      return "";
    }
  }

  const addNewRow = () => {
    if(!newItem?.branch){
      ToastError({ title: `${_t(t("Please select branch first"))}` });
      return;
    }
    setNewRow((pre) => [...pre, {
      item_name: "",
      qty: "",
      unit: "",
      item_units: "",
      rate: 0,
      tax_percent: "",
      tax: "",
      gst_tax: "",
      base_unit: "",
      base_qty: "",
      conversion_qty: ""
    }])
  }

  const delRow = (id) => {
    let row = [...newRow];
    if (id > -1) {
      row.splice(id, 1);
    }
    setNewRow(row);
  }

  return (
    <>
      <Helmet>
        <title>{_t(t((id && !isReplicated) ? "Edit Purchase Order" : "Add Purchase Order"))}</title>
      </Helmet>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <div className={`${loading && "loading"}`}></div>
                    {/* spin loading ends */}

                    {/* Loading effect */}
                    {dataPaginating === true ? (
                      tableLoading()
                    ) : (
                      <div key="smtp-form">
                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {_t(t((id && !isReplicated) ? "Edit Purchase Order" : "Add Purchase Order"))}
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-6 col-lg-7">
                            <div className="row gx-3 align-items-center"></div>
                          </div>
                        </div>

                        {/* Form starts here */}
                        <form
                          className="row card p-2 mx-3 mb-5 table-text"
                          onSubmit={handleSubmit}
                          autoComplete="off"
                        >
                          <div className="col-12">
                            <div className="row">
                              {branchForSearch && (
                                <>
                                  <div className="form-group col-3 mt-2">
                                    <div className="mb-2">
                                      <label
                                        htmlFor="invoice"
                                        className="control-label"
                                      >
                                        {_t(t("PO #"))}
                                      </label>
                                    </div>
                                    <div className="mb-2">
                                      <input
                                        disabled={true}
                                        type="text"
                                        className="form-control table-text"
                                        id="invoice"
                                        name="invoice"
                                        // onChange={handleChange}
                                        value={newItem.identity}
                                        placeholder="Auto No"
                                      />
                                    </div>
                                  </div>

                                  <div className="form-group col-2 mt-2">
                                    <div className="mb-2 ">
                                      <label
                                        htmlFor="purchaseDate"
                                        className="control-label"
                                      >
                                        {_t(t("PO Date"))}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>
                                    <div className="mb-2">
                                      <DatePicker
                                        disabled
                                        selected={newItem.date}
                                        onChange={(date) => setNewItem({ ...newItem, date })}
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        className="form-control table-text"
                                        placeholderText={_t(t("Purchase date"))}
                                        shouldCloseOnSelect={false}
                                      />
                                    </div>
                                  </div>

                                  <div className="form-group col-2 mt-2">
                                    <div className="mb-2 ">
                                      <label
                                        htmlFor="purchaseDate"
                                        className="control-label"
                                      >
                                        {_t(t("Delivery Date"))}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>
                                    <div className="mb-2">
                                      <DatePicker
                                        selected={newItem.delivery_date}
                                        onChange={(date) => setNewItem({ ...newItem, delivery_date: date })}
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        minDate={new Date()}
                                        dropdownMode="select"
                                        className="form-control table-text"
                                        placeholderText={_t(t("Delivery date"))}
                                        shouldCloseOnSelect={false}
                                      />
                                    </div>
                                  </div>

                                  <div className="form-group col-1 text-right mt-3">
                                    <div className="mb-2 text-left">
                                      <label
                                        htmlFor="is_ref_no"
                                        className="control-label"
                                      >
                                        {_t(t("Ref No."))}
                                      </label>
                                    </div>
                                    <div className="mb-2 float-left">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="is_ref_no"
                                        name="is_ref_no"
                                        onChange={() => handleCheckRef()}
                                        checked={newItem.is_ref_no}
                                        disabled={id}
                                      />
                                    </div>
                                  </div>

                                  <div className="form-group mt-2 col-4">
                                    <div className="mb-1 text-left">
                                      <label
                                        htmlFor="branch"
                                        className="control-label text-truncate"
                                      >
                                        {_t(t("Branch"))}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>
                                    <Select
                                      options={branchForSearch}
                                      components={makeAnimated()}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      value={newItem.branch || ""}
                                      isDisabled={id}
                                      classNamePrefix="select"
                                      onChange={handleSetBranch}
                                      maxMenuHeight="200px"
                                      placeholder={
                                        _t(t("Please select branch")) + ".."
                                      }
                                      styles={customStyle}
                                      required
                                    />
                                  </div>
                                </>
                              )}
                            </div>
                            <div className="row">
                              <div className="form-group mt-2 col-3">
                                <div className="mb-2 ">
                                  <label
                                    htmlFor="supplier"
                                    className="control-label"
                                  >
                                    {_t(t("Supplier/Vendor"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <Select
                                  options={supplierForSearch}
                                  components={makeAnimated()}
                                  getOptionLabel={(option) => option.name}
                                  getOptionValue={(option) => option.id}
                                  value={newItem.supplier || ""}
                                  classNamePrefix="select table-text"
                                  onChange={handleSetSupplier}
                                  placeholder={
                                    _t(t("Please select a supplier")) + ".."
                                  }
                                  styles={customStyle}
                                  required
                                />
                              </div>
                              <div className="form-group mt-2 col-3">
                                <div className="mb-1 text-left">
                                  <label
                                    htmlFor="branch"
                                    className="control-label text-truncate"
                                  >
                                    {_t(t("Ref No (PR)"))}
                                  </label>
                                </div>
                                <Select
                                  options={purchaseReqRef ?? []}
                                  isDisabled={!newItem.branch || !newItem.is_ref_no || loading || id}
                                  components={makeAnimated()}
                                  getOptionLabel={(option) => option.document_identity}
                                  getOptionValue={(option) => option.id}
                                  value={newItem.purchase_req || ""}
                                  classNamePrefix="select"
                                  onChange={(data) => handleSetRefNo(data)}
                                  maxMenuHeight="200px"
                                  placeholder={
                                    _t(t("Please select ref")) + ".."
                                  }
                                  styles={customStyle}
                                  required
                                />
                              </div>
                              <div className="form-group mt-2 col-6">
                                <div className="mb-2">
                                  <label
                                    htmlFor="description"
                                    className="control-label"
                                  >
                                    {_t(t("Description"))}
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <input
                                    type="text"
                                    className="form-control table-text"
                                    id="description"
                                    name="description"
                                    onChange={handleDesc}
                                    value={newItem.description}
                                    placeholder="Short description"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="table-responsive mt-3 pr-1" style={{ maxHeight: "23rem", overflow: "auto" }}>
                              <table className="table table-bordered-sm table-hover">
                                <thead className="align-middle">
                                  <tr>
                                    {newRow.length == 0 ? <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span className="t-mr-10" onClick={() => addNewRow()}>
                                        <i className="fa fa-plus-circle cursor-pointer btn-add-icon" style={{ fontSize: "22px" }} aria-hidden="true"></i>
                                      </span>
                                    </th> : <th style={{ borderBottomColor: "lightgray" }}></th>}
                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border "
                                      style={{ minWidth: "12rem" }}
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Name"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border "
                                      style={{ minWidth: "12rem" }}
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("PR Qty"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Qty"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                      style={{ minWidth: "12rem" }}
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Unit"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Rate"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Amount"))}
                                      </span>
                                    </th>

                                     <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Tax (%)"))}
                                      </span>
                                    </th>


                                       <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Tax Amount"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Total"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                      style={{ minWidth: "9rem" }}
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Conversion unit"))}
                                      </span>
                                    </th>
                                    {newRow.length > 0 && <th style={{ borderBottomColor: "lightgray", minWidth: "60px" }}></th>}
                                  </tr>
                                </thead>
                                {newRow && newRow.length > 0 ?
                                  <tbody className="align-middle">
                                    {newRow.map(
                                      (ingredientItem, index) => {
                                        const basePrice = Number(
                                            ingredientItem?.isEdit
                                              ? ingredientItem?.price
                                              : ingredientItem?.item_name?.price
                                          );
                                        const maxPrice =
                                          newItem?.branch?.po_price_increase_pct && basePrice
                                            ? basePrice * (1 + newItem?.branch.po_price_increase_pct / 100)
                                            : undefined;
                                        return (
                                          <tr
                                            className="align-middle"
                                            key={index}
                                          >
                                            <td className="table-text text-capitalize align-middle text-center table-firstChild" style={{ minWidth: "60px" }}>
                                              {index == (newRow.length - 1) && <span className="t-mr-10" onClick={() => addNewRow()}>
                                                <i className="fa fa-plus-circle btn-add-icon" style={{ fontSize: "22px" }} aria-hidden="true"></i>
                                              </span>}&nbsp;
                                              <i className="fa fa-minus-circle cursor-pointer text-danger" style={{ fontSize: "22px" }}
                                                onClick={() => { delRow(index) }}
                                              ></i>
                                            </td>

                                            <td className="table-text text-capitalize align-middle text-center table-Child">
                                              {ingredientItem?.isEdit ?
                                                <input
                                                  readOnly
                                                  type="text"
                                                  className={`form-control text-center table-Input table-text`}
                                                  value={ingredientItem.item_name || ""}
                                                />
                                                :
                                                <Select
                                                  options={ingredientItemNonPurchase}
                                                  getOptionLabel={(option) => option.name}
                                                  getOptionValue={(option) => option.id}
                                                  classNamePrefix="select table-text"
                                                  onChange={(e) => handleSetItems(index, e)}
                                                  value={ingredientItem.item_name}
                                                  placeholder={
                                                    _t(t("Please select items")) + ".."
                                                  }
                                                  menuPosition="fixed"
                                                  styles={customStyle}
                                                />
                                              }
                                            </td>

                                            <td className="table-text text-capitalize align-middle text-center" style={{ width: "15%" }}>
                                              <input
                                                type="number"
                                                readOnly
                                                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                                className="form-control text-center table-Input table-text"
                                                id={ingredientItem.id}
                                                name={ingredientItem.id}
                                                value={ingredientItem.remaining_qty ? ingredientItem.remaining_qty : ""}
                                              />
                                            </td>

                                            <td className="table-text text-capitalize align-middle text-center" style={{ width: "15%" }}>
                                              <input
                                                type="number"
                                                step={qtyAmountPoints()}
                                                min="0"
                                                onKeyDown={(evt) =>
                                                  ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) &&
                                                  evt.preventDefault()
                                                }
                                                onWheel={(e) => e.target.blur()}
                                                className="form-control text-center table-Input table-text"
                                                id={ingredientItem.id}
                                                name={ingredientItem.id}
                                                onChange={(e) => handleItemQty(index, e)}
                                                value={ingredientItem.qty}
                                                placeholder="Qty"
                                                max={(parseInt(getSystemSettings(generalSettings, "allow_access_quantity")) === 0 && newItem.purchase_req && ingredientItem.remaining_qty) ? Number(ingredientItem.remaining_qty) : undefined}
                                                required
                                              />
                                            </td>

                                            <td className="table-text text-capitalize align-middle text-center">
                                              {ingredientItem?.isEdit ?
                                                <input
                                                  readOnly
                                                  type="text"
                                                  className={`form-control text-center table-Input table-text`}
                                                  value={ingredientItem.unit_name || ""}
                                                />
                                                :
                                                <Select
                                                  menuPosition="fixed"
                                                  options={ingredientItem.item_units ? ingredientItem.item_units : []}
                                                  getOptionLabel={(option) => option.name}
                                                  getOptionValue={(option) => option.id}
                                                  value={ingredientItem.unit}
                                                  classNamePrefix="select"
                                                  onChange={(e) => handleSetUnit(index, e)}
                                                  styles={customStyle}
                                                  placeholder={
                                                    _t(t("please select unit")) + ".."
                                                  }
                                                  isDisabled={ingredientItem.item_units ? false : true}
                                                />
                                              }
                                            </td>
                                            <td className="table-text text-capitalize align-middle text-center" style={{ width: "15%" }}>
                                              <input
                                                type="number"
                                                step={qtyAmountPoints()}
                                                min="0"
                                                onKeyDown={(evt) =>
                                                  ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) &&
                                                  evt.preventDefault()
                                                }
                                                onWheel={(e) => e.target.blur()}
                                                className="form-control text-center table-Input table-text"
                                                id={ingredientItem.id}
                                                name={ingredientItem.id}
                                                onChange={(e) => handleItemRate(index, e)}
                                                value={ingredientItem.rate}
                                                placeholder="Price"
                                                max={maxPrice}
                                                required
                                              />
                                            </td>

                                 

                                            <td className="table-text align-middle text-center">
                                              {formatPrice(
                                                handleGetAmount(index)
                                              )}
                                            </td>
                                          
                                           <td className="table-text text-capitalize align-middle text-center" style={{ width: "12%" }}>
                                              <input
                                                type="number"
                                                step={qtyAmountPoints()}
                                                min="0"
                                                onKeyDown={(evt) =>
                                                  ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) &&
                                                  evt.preventDefault()
                                                }
                                                onWheel={(e) => e.target.blur()}
                                                className="form-control text-center table-Input table-text"
                                                onChange={(e) => handleItemTax(index, e)}
                                                value={ingredientItem.tax_percent ?? ingredientItem.tax ?? ingredientItem.gst_tax ?? ""}
                                                placeholder="Tax (%)"
                                              />
                                            </td>


                                            <td className="table-text align-middle text-center">
                                              {formatPrice(
                                                handleGetTaxAmount(index)
                                              )}
                                            </td>

                                            <td className="table-text align-middle text-center">
                                              {formatPrice(
                                                handleGetSubTotal(index)
                                              )}
                                            </td>

                                            <td className="table-text align-middle text-center">
                                              {ingredientItem.conversion_qty}
                                            </td>

                                            <td className="table-text text-capitalize align-middle text-center" style={{ minWidth: "60px" }}>
                                              <i className="fa fa-minus-circle cursor-pointer text-danger" style={{ fontSize: "22px" }} onClick={() => { delRow(index) }}></i>&nbsp;
                                              {index == (newRow.length - 1) && <span className="t-mr-10" onClick={() => addNewRow()}>
                                                <i className="fa fa-plus-circle cursor-pointer btn-add-icon" style={{ fontSize: "22px" }} aria-hidden="true"></i>
                                              </span>}
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )}
                                  </tbody>
                                  : null}
                                {newRow && newRow.length > 0 ?
                                  <tfoot className="align-middle">
                                    <tr>
                                      <th
                                        style={{ minWidth: "100px" }}
                                        scope="col"
                                        colSpan="8"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>

                                      <th
                                        style={{ minWidth: "100px" }}
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{ fontWeight: 500 }}>
                                          {_t(t("Total"))}
                                        </span>
                                      </th>

                                      <th
                                        style={{ minWidth: "100px" }}
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        {formatPrice(handleGetTotal())}
                                      </th>
                                      <th
                                        style={{ minWidth: "100px" }}
                                        scope="col"
                                        colSpan="2"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                      </th>
                                    </tr>

                                  </tfoot>
                                  : null}
                              </table>
                            </div>
                            <div className="form-group mt-4 pb-2">
                              <div className="d-flex justify-content-end align-items-center">
                                <div className="col-3 d-flex justify-content-end">
                                  <button
                                    type="button"
                                    className="btn rounded hov-btn mr-3"
                                    onClick={() => (history.push("/dashboard/manage/stock/purchase-order"))}
                                  //   data-dismiss="modal"
                                  >
                                    <i class="fa fa-arrow-left" aria-hidden="true"></i> {_t(t("Back"))}
                                  </button>
                                  <button
                                    disabled={loading}
                                    type="submit"
                                    className="btn btn-primary rounded"
                                  >
                                    <i class="fa fa-floppy-o" aria-hidden="true"></i> {_t(t("Save"))}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
    </>
  )
}

export default PurchaseOrderAction
